import { WorkOrderBoard } from "../../components/fleet/WorkOrderBoard";

export default function FleetWorkOrders() {
  return <WorkOrderBoard />;
}
